import { emailRegex } from "core/utils/emailRegex";
import type { FieldPath, FieldValues } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  ReactHookTextField,
  type ReactHookTextFieldProps,
} from "./ReactHookTextField";

export function ReactHookEmailInput<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({ ...props }: ReactHookTextFieldProps<TFieldValues, TName>) {
  const { t } = useTranslation("Fixhub", {
    keyPrefix: "Next:Core:ReactHookEmailInput",
  });
  return (
    <ReactHookTextField
      autoComplete="email"
      rules={{
        pattern: {
          message: t("invalidEmail"),
          value: emailRegex,
        },
      }}
      {...props}
    />
  );
}
